import type { GridProps} from '@chakra-ui/react'
import { Grid, Image } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { useWizzardHeader } from '../../context/WizzardHeaderContext'
// import car from '../../images/apps/pinCar.svg'
import car from '../../images/apps/travel.png'

export interface WizzardHeaderTravelInfoProps extends GridProps {

}

export const WizzardHeaderTravelInfo = (props: WizzardHeaderTravelInfoProps) => {
  const { isScrolled } = useWizzardHeader()
  const [logoSize, setLogoSize] = useState(150)

  useEffect(() => {
    setLogoSize(isScrolled ? 90 : 150)
  }, [isScrolled])

  return (
    <Grid
      sx={{
        position: 'relative',
        w: { base: '100%', md: '250px' },
        gridTemplateColumns: {
          base: 'auto 1fr',
          md: '1fr',
        },
        mt: { md: isScrolled ? -6 : -8 },
        mb: { md: -4 },
        borderRadius: { base: 'md', md: 0 },
        overflow: {
          base: 'hidden',
          md: 'visible',
        },
        transition: 'all 200ms ease-in-out',
      }}
    >
      <Grid
        sx={{
          p: { base: 2, md: isScrolled ? 3 : 6 },
          justifyContent: 'center',
          bg: 'white',
          borderTopRadius: { md: 'md' },
          transition: 'all 200ms ease-in-out',
        }}
      >
        <Image
          src={car}
          sx={{
            width: {
              base: 12,
              md: `${logoSize}px`,
            },
            height: {
              base: 12,
              md: `${logoSize}px`,
            },
            transition: 'all 200ms ease-in-out',
          }}
        />
      </Grid>

      {/* <Grid
        sx={{
          px: 4,
          pt: { base: 0, md: 2 },
          pb: { base: 0, md: isScrolled ? 2 : 4 },
          alignContent: 'center',
          alignItems: 'center',
          bg: 'neutral.50',
        }}
      >
      </Grid> */}
    </Grid>
  )
}
